import React from 'react';

import './PromptFieldCard.css';

const normalizeTypeClass = (value) =>
  String(value || 'prompt')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-');

const PromptFieldCard = ({
  title,
  type,
  contextLabel,
  contextValue,
  selected = false,
  pending = false,
  dragging = false,
  linked = false,
  compact = false,
  className = '',
  onClick,
  onPointerDown,
  style,
}) => {
  const typeClass = normalizeTypeClass(type);
  const safeTitle = title || 'Untitled prompt';

  return (
    <button
      type="button"
      className={`prompt-field-card ${selected ? 'prompt-field-card--selected' : ''} ${
        pending ? 'prompt-field-card--pending' : ''
      } ${dragging ? 'prompt-field-card--dragging' : ''} ${
        linked ? 'prompt-field-card--linked' : ''
      } ${compact ? 'prompt-field-card--compact' : ''} ${className}`.trim()}
      onClick={onClick}
      onPointerDown={onPointerDown}
      style={style}
      aria-label={safeTitle}
    >
      <div className="prompt-field-card__top">
        <span className={`prompt-field-card__type prompt-field-card__type--${typeClass}`}>
          {type || 'Prompt'}
        </span>
      </div>

      <h4 className="prompt-field-card__title">{safeTitle}</h4>

      <div className="prompt-field-card__context">
        <span className="prompt-field-card__context-label">{contextLabel || 'Context'}</span>
        <span className="prompt-field-card__context-value">{contextValue || '--'}</span>
      </div>
    </button>
  );
};

export default PromptFieldCard;
